import { PatientOrder, PatientOrderControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Atish Bagade
 */
export const useEditLabRequisition = () =>
  useMutationWithLoading(
    async (params: { patientOrder: PatientOrder; xTENANTID?: string }) =>
      new PatientOrderControllerApi(getConfigObject()).updatePatientOrder(
        params.patientOrder,
        params.xTENANTID
      )
  );
